export default __webpack_public_path__ + "static/canyoneering-f89d4901bc4e953aa9803dabaddccdd6.jpeg";